import { useEffect, useState } from "react";
import { subscribe, useSnapshot } from "valtio";
import { Agyesno } from "../components/Agyesno";
import { AgmodalStore, airChargesStore, bookingsStore, cargoStore, chargesStore1, configStore, containerStore, contractsStore, fclChargesStore, loginStore, quoteDataRec } from "../state/CommonState";
import Igmmanifesttable from "./igm-manifest-table";
import Taskfiledisplay from "./task-file-display";
import Taskfiletable from "./task-file-table";
import { taskStore } from "./task-store";
import Taskapi, { Task } from "./tasks-api";
import { AgRoute } from "./AgRoute";
import { Details } from "../v3-componets/AgDetails";
import { useForm } from "react-hook-form";
import { enquiryStore } from "../enquiry/enquiry-data";
import { loader } from "../util/loader";
import { Card } from "reactstrap";
import { Headspan } from "../v3-componets/AgHeadspan";
import ship1 from "../assets/images/ship1.svg";
import { Col3 } from "../Controls";
import { AgUnloc } from "../components/AgComponents";
import { chargesValidationStore, QuotationValidationStore } from "../state/validation-stores";
import { shipmentScopeList, stuffingTypes } from "../StaticData";
import { ControlledDetailSwitch } from "../v3-componets/AgControlledDetailSwitch";
import { AntSwitch } from "../mui-components/AntSwitch";
import { ActChargesAirComp, ActChargesAirView, ActChargesComp, ActChargesView, ActFCLChargesComp, ActFCLChargesView, ActrejectModal } from "./act-additional-cost-approval";
import Api from "../state/Api";
import { Route } from "../v3-componets/AgRoute.js";
import MonApi, { GET_ADDRESSDETAILS_BY_FILTER_URI, GET_MYACTIONS_MEASUREMENT_SLIP_URI } from '../state/mongo-api';
import Utils from "../util/Utils.js";
import { AgTextShow } from "../components/AgCustomComponents.js";
import QuoteCalcV2 from "../util/quote-calc-v2.js";
import { calcCargoDetails } from "../CargoComp.js";
import BookingsApi from "../state/bookings-api.js";


export default function BookingAmendment(props) {
  useSnapshot(taskStore)
  useSnapshot(configStore)
  useSnapshot(contractsStore)
  useSnapshot(enquiryStore)
  let bookingData = useSnapshot(bookingsStore)
  let task = taskStore.current
  let stage = task.stage
  const [show, setShow] = useState(false);
    const [chargelist, setChargelist] = useState([])

  const [disableButton, setDisableButton] = useState(true)
  const [view, setView] = useState(() => !!taskStore.current.changesRequired);
  const [obj, setObj] = useState({ portOfReceipt: true, portOfLoading: true, portOfDischarge: true, finalPlaceOfDelivery: true,reworkingPort:true })
  if((taskStore.current.oldchargesList==undefined || taskStore.current.oldchargesList.length==0) && chargelist.length>0){
      taskStore.current.oldchargesList = chargelist
  }
  let stype = taskStore.current.shipmentType
  let key = ''
    if(stype.toUpperCase().indexOf('FCL') > -1){
        key = 'FCL'
    }else if(stype.toUpperCase().indexOf('AIR') > -1){
        key = 'AIR'
    }else{
        key = 'LCL'
    }

    
  const _params = (label, name, type = "text", dataList = []) => {
    return {
      type,
      name,
      label,
      record: taskStore.current,
      dataList,
    };
  };
  const portOfReceiptLable =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of Receipt"
      : "Place of Receipt";
  const portOfLoadingLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of departure"
      : "* Port of Loading";
  const portOfDischargeLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of Arrival"
      : "Port of Discharge";

const cargoStructure = ()=>{
  let b = JSON.parse(JSON.stringify(bookingsStore.current.contract))
  const md = (m) =>{
    for (let i = 0; i < m.length; i++) {
      m[i]['cargoDetails'] = setcargo(m[i]['cargoDetails'])
    }
    return m
  }
  if(b.orginalMD!=undefined){
    return md(b.orginalMD)
  }else if(b.multidest!=undefined){
    return md(b.multidest)
  }else{
    return [
                    {
                        destination:b.destination,
                        cargoDetails:b.cargoDetails,
                    }
                ]
  }
}
const setcargo = (cargolist)=>{
            let cargo = []
            if(cargolist.length>0){
              for (let i = 0; i < cargolist.length; i++) {
                let l = cargolist[i]
                if (l['weight'] == undefined) {
                  if(cargolist[i]['weightPerPackage']==undefined){
                    cargolist[i]['weightPerPackage'] = "Kgs"
                  }
                  if(l['quantity']==undefined){
                    l["quantity"]=+cargolist[i]['numPackages']
                  }
                    l['weight'] = {value:+cargolist[i]['wtPerPackage'],unit:cargolist[i]['weightPerPackage']}
                   
                    l['dimensions'] = {
                      "length":+cargolist[i]['length'],
                      "width":+cargolist[i]['width'],
                      "height":+cargolist[i]['height']
                    }
                    let shipmentType = enquiryStore.current.shipmentType;
                    let calculatedCargo = calcCargoDetails(cargolist[i], (enquiryStore.current.shipmentScope !== "Port-to-Port" || shipmentType.toLowerCase().includes('air') || shipmentType.toLowerCase().includes('fcl')),enquiryStore.current.volumeInDimensions)
                    l['totalWeight'] = {"value":+calculatedCargo['totalWeight'],"unit":"Kgs"}
                    l['totalVolume'] = {"value":+calculatedCargo['totalVolume'],"unit":"CBM"}
                }
                cargo.push(l)
              }  
            }
            return cargo
}

  const oldCargoForm = useForm({
    defaultValues: {
      mode: bookingsStore.current.contract.shipmentType.toLowerCase().includes('fcl') ? 'FCL' : bookingsStore.current.contract.shipmentType,
      orginScope: false,
      destinationScope: false,
      originType: false,
      destinationType: false,
      showCargoDetailsOutGuage: false,
      showPalletLabel: false,
      multidest: cargoStructure() ,
      containerDetails: bookingsStore.current.contract.containerList,
      fbaalways: "Yes",
      origin: bookingsStore.current.contract.origin,
      cargoreadinessdate: bookingsStore.current.contract.cargoReadinessDate,
      scope: bookingsStore.current.contract.shipmentScope,
      customerreference: bookingsStore.current.contract.customerReferenceNum,
      hazardous: (bookingsStore.current.contract.hazardous == 'No' ? false : true),
      quoteClass: bookingsStore.current.contract.quoteClass,
      packingGroup: bookingsStore.current.contract.packingGroup,
      temperature: bookingsStore.current.contract.temperature,
      cargoValue: bookingsStore.current.contract.cargoValue,
      unnumber: bookingsStore.current.contract.unnumber,
      nonStackable: (bookingsStore.current.contract.nonStackable == 'No' ? false : true),
      temperatureControlled: (bookingsStore.current.contract.temperatureControlled == 'No' ? false : true),
      minTemperature: bookingsStore.current.contract.minTemperature,
      maxTemperature: bookingsStore.current.contract.maxTemperature,
      stuffingType: bookingsStore.current.contract.stuffingType,
      destuffingType: bookingsStore.current.contract.destuffingType,
      cargoDimensionUnit: bookingsStore.current.contract.cargoDimensionUnit,
      warehouse:bookingsStore.current.contract.warehouse,
      volumeInDimensions : bookingsStore.current.contract.volumeInDimensions ?? true,
      isFba: (bookingsStore.current.contract.fba == 'Yes' ? true : false),
      ior: (bookingsStore.current.contract.fbaIorRequired == 'Yes' ? true : false),
      iorParty : bookingsStore.current.contract.iorParty ,
      occ: (bookingsStore.current.contract.fbaOCC == 'Yes' ? true : false),
      dcc: (bookingsStore.current.contract.fbaDCC == 'Yes' ? true : false),
      opal: bookingsStore.current.contract.opal,
      dpal: bookingsStore.current.contract.dpal,
      survey: (bookingsStore.current.contract.fbaSurvey == 'Yes' ? true : false),
      overHeight:bookingsStore.current.contract.overHeight === "Yes" ? true :false,
      overlength:bookingsStore.current.contract.overlength === "Yes" ? true :false,
      topLoading:bookingsStore.current.contract.topLoading === "Yes" ? true :false,
      fumigation:bookingsStore.current.contract.fumigation === "Yes" ? true :false,
      headLoad:bookingsStore.current.contract.headLoad === "Yes" ? true :false,
      doorLoad:bookingsStore.current.contract.doorLoad === "Yes" ? true :false,
      reefer:bookingsStore.current.contract.reefer === "Yes" ? true :false,
      overHeightValue:bookingsStore.current.contract.overHeightValue,
      overlengthValue:bookingsStore.current.contract.overlengthValue,
      storageAtDestination: (bookingsStore.current.contract.fbaSAD == 'Yes' ? true : false),
      palletizationandlabelling: (bookingsStore.current.contract.fbaPAL == 'Yes' ? true : false),
      days: (bookingsStore.current.contract.fbaDays != undefined ? bookingsStore.current.contract.fbaDays : 0),
      cartingorder:(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0)?true:false

    }
  })
  let newData = { ...bookingsStore.current.contract, ...taskStore.current.newContract }
  const newCargoForm = useForm({
    defaultValues: {
      mode: newData.shipmentType.toLowerCase().includes('fcl') ? 'FCL' : bookingsStore.current.contract.shipmentType,
      orginScope: false,
      destinationScope: false,
      originType: false,
      destinationType: false,
      showCargoDetailsOutGuage: false,
      showPalletLabel: false,
      multidest: newData.multidest,
      containerDetails: newData.containerList,
      fbaalways: "Yes",
      origin: newData.origin,
      cargoreadinessdate: newData.cargoReadinessDate,
      scope: newData.shipmentScope,
      customerreference: newData.customerReferenceNum,
      hazardous: newData.hazardous == 'No' ? false : true,
      quoteClass: newData.quoteClass,
      packingGroup: newData.packingGroup,
      temperature: newData.temperature,
      cargoValue: newData.cargoValue,
      unnumber: newData.unnumber,
      nonStackable: newData.nonStackable == 'No' ? false : true,
      temperatureControlled: newData.temperatureControlled == 'No' ? false : true,
      minTemperature: newData.minTemperature,
      maxTemperature: newData.maxTemperature,
      stuffingType: newData.stuffingType,
      destuffingType: newData.destuffingType,
      cargoDimensionUnit: newData.cargoDimensionUnit,
      warehouse:newData.warehouse,
      volumeInDimensions : newData.volumeInDimensions ?? true,
      isFba: newData.fba == 'Yes' ? true : false,
      ior: newData.fbaIorRequired == 'Yes' ? true : false,
      iorParty : newData.iorParty,
      occ: newData.fbaOCC == 'Yes' ? true : false,
      dcc: newData.fbaDCC == 'Yes' ? true : false,
      opal: newData.opal,
      dpal: newData.dpal,
      survey: newData.fbaSurvey == 'Yes' ? true : false,
      storageAtDestination: newData.fbaSAD == 'Yes' ? true : false,
      palletizationandlabelling: newData.fbaPAL == 'Yes' ? true : false,
      days: newData.fbaDays != undefined ? newData.fbaDays : 0,
      overHeight:newData.overHeight === "Yes" ? true :false,
      overlength:newData.overlength === "Yes" ? true :false,
      topLoading:newData.topLoading === "Yes" ? true :false,
      fumigation:newData.fumigation === "Yes" ? true :false,
      headLoad:newData.headLoad === "Yes" ? true :false,
      doorLoad:newData.doorLoad === "Yes" ? true :false,
      reefer:newData.reefer === "Yes" ? true :false,
      overHeightValue:newData.overHeightValue,
      overlengthValue:newData.overlengthValue,

    }
  })
  const { control, watch, register, setValue, handleSubmit, resetField, clearErrors, formState, trigger, getFieldState, getValues:getValuesNewForm } = newCargoForm;
let containerDetails = watch('containerDetails')
function addlist(){
        if(taskStore.current.chargesList.length==0){
            switch (key) {
                case 'FCL':
                    containerStore.list = bookingsStore.current.contract.containerList
                    fclChargesStore.colNames = {
                        twoSpan: '',
                        twoSpan1: 'Per Container',
                        twoSpan2: '',
                        perShipment: 'Per BL'
                    }
                    fclChargesStore.initialLength = 0
                    fclChargesStore.list = [{
                        id: 1,
                        chargeDescription: '',
                        currency: 'INR'
                    }]
                    taskStore.current.chargesList = fclChargesStore.list
                    break;
                case 'AIR':
                    containerStore.list = bookingsStore.current.contract.containerList
                    airChargesStore.initialLength = 0
                    airChargesStore.list = [
                        {
                            id: 1,
                            chargeDescription: '',
                            currency: 'INR'
                        }
                    ]
                    taskStore.current.chargesList = airChargesStore.list
                    break;
                case 'LCL':
                    chargesStore1.initialLength = 0
                    chargesStore1.list = [
                        {
                            id: 1,
                            chargeDescription: '',
                            currency: 'INR',
                            perCBM: 0,
                            perTon: 0,
                            minimum: 0,
                            maximum: 0
                        }
                    ]
                    taskStore.current.chargesList = chargesStore1.list
                    break;
            }
        }else{
            const getdata = (a) =>{
                let k = []
                if(a!=undefined){
                    for (let i = 0; i < a.length; i++) {
                        a[i]["id"] = i+1
                        k.push(a[i])
                    }
                }
                return k
            }
            let k = getdata(taskStore.current.chargesList)
            console.log("++++",k)
            switch (key) {
                case 'FCL':
                    containerStore.list = containerDetails
                    fclChargesStore.list = k
                    break;
                case 'AIR':
                    containerStore.list = containerDetails
                    airChargesStore.list = k
                case 'LCL':
                k = Utils.groupedCategoryChargeList({ chargeList: k })
                    chargesStore1.list = k
                    break;
            }
            console.log(containerStore.list,"containerStore.list09-=---",fclChargesStore.list);
            
            if(JSON.stringify(k)!=JSON.stringify(taskStore.current.chargesList)){
                taskStore.current.chargesList = k
            }
        }
    }

function check(){
        if(stage==2){
            let disable = false
             let cargo = []
                  let multidest_new = []
            switch (key) {
      case 'FCL':
        let container =[]
          let obj1 = {}
              for (let j = 0; j < containerDetails?.length; j++) {
                if(containerDetails[j]['containerType']!=undefined && containerDetails[j]['containerType'].length>0){
                  let c = containerDetails[j]['containerType']
                  if(obj1[c]==undefined){
                      obj1[c] = {
                          containerType : "",
                          numContainers: 0,
                          unit: "",
                          wtPerContainer: 0
                      }
                  }
                  obj1[c]['containerType'] = c
                  obj1[c]['unit'] = 'Kgs'
                  obj1[c]['numContainers'] = obj1[c]['numContainers']+Number(containerDetails[j]['numContainers'])
                  obj1[c]['wtPerContainer'] = Number(Utils.toUnit(containerDetails[j]['wtPerContainer'], containerDetails[0]['unit']))
                }
              }
            let o = Object.keys(obj1)
            console.log("🚀 ~ check ~ o:", o)
            for (let i = 0; i < o.length; i++) {
                container.push(obj1[o[i]])
            }
            if(JSON.stringify(containerStore.list)!=JSON.stringify(container)){
                containerStore.list = JSON.parse(JSON.stringify(container))
              }
              if(JSON.stringify(containerStore.list)!=JSON.stringify(bookingsStore.current.contract.containerDetails)){
                  taskStore.current.chargesList = fclChargesStore.list
              }
                    fclChargesStore.actcalculateChargesTotals(quoteDataRec.emptycontainerweight)
                    taskStore.current.chargesList.map((e)=>{
                        if(e['chargeDescription'].length==0 || e['currency'].length==0){
                            disable=true
                        }
                        let a = false
                        // containerDetails.map((e1)=>{
                        //     if(!a){
                        //         if(e[e1['containerType']+'total'] != undefined){
                        //             if(e[e1['containerType']+'total']==0 && e['chargeDescription'] !='Marine Insurance'){
                        //                 disable=true
                        //             }else{
                        //                 a = true
                        //                 disable=false
                        //             }
                        //         }else{
                        //             disable=true
                        //         }
                        //     }
                        // })
                    })
                    
                    break;
                case 'AIR':
                    if(airChargesStore.list.length==0) addlist()
                      cargo = []
           multidest_new = []
            for (let i = 0; i < data.multidest?.length; i++) {
              let z = {}
              z['destination'] = multidest[i]['destination']
              z['cargoDetails'] = []
              for (let j = 0; j < multidest[i]['cargoDetails'].length; j++) {
                let k = multidest[i]['cargoDetails'][j]
                k = Utils.setCargo_unit(k,multidest[0]['cargoDetails'][0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                let c = Utils.convert_calcCargoDetails(multidest[i]['cargoDetails'][j],scope,bookingsStore.current.contract.shipmentType,false,bookingsStore.current.contract.cargoDimensionUnit,data.volumeInDimensions)
                z['cargoDetails'].push(c)
                cargo.push(c)
              }
              multidest_new.push(z)
            }
                    if(JSON.stringify(cargoStore.cargoList) != JSON.stringify(bookingsStore?.current?.contract?.cargoList)){
                        cargoStore.cargoList = JSON.parse(JSON.stringify(cargo))
                    }
                    cargoStore.calculateCargoTotals()
                    airChargesStore.actcalculateChargesTotals()
                    taskStore.current.chargesList.map((e)=>{
                        if(e['chargeDescription'].length==0 || e['currency'].length==0){
                            disable=true
                        }
                        // if(e['total']!=undefined){
                        //     if(e['total']==0){
                        //         disable=true
                        //     }
                        // }else{
                        //     disable=true
                        // }
                    })
                    
                    break;
                case 'LCL':
                    if(chargesStore1.list.length==0) addlist()
                      cargo = []
                  multidest_new = []
                    for (let i = 0; i < data.multidest?.length; i++) {
                      let z = {}
                      z['destination'] = multidest[i]['destination']
                      z['cargoDetails'] = []
                      for (let j = 0; j < multidest[i]['cargoDetails'].length; j++) {
                        let k = multidest[i]['cargoDetails'][j]
                        k = Utils.setCargo_unit(k,multidest[0]['cargoDetails'][0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                        let c = Utils.convert_calcCargoDetails(multidest[i]['cargoDetails'][j],scope,bookingsStore.current.contract.shipmentType,false,bookingsStore.current.contract.cargoDimensionUnit,data.volumeInDimensions)
                        z['cargoDetails'].push(c)
                        cargo.push(c)
                      }
                      multidest_new.push(z)
                    }
                    if(JSON.stringify(cargoStore.cargoList) != JSON.stringify(cargo)){
                        cargoStore.cargoList = JSON.parse(JSON.stringify(cargo))
                    }
                    cargoStore.calculateCargoTotals()
                    chargesStore1.actcalculateChargesTotals()
                    break;
            }
    
      //       if (taskStore.current.chargesList.length == 0 || taskStore.current.chargesList.filter(e=>e.chargeDescription).some(e => e.chargeDescription === '' || e.onaccount=='' ||
      //   (e.hasOwnProperty('total') && (e.total == '') ||
      //  !Object.keys(e).some(key => key.endsWith('total') && e.hasOwnProperty(key) && (e[key] != ''))
      //   ))){
      //           disable = true
      //       }
            if(!taskStore.current.isValid && !disable){
                taskStore.current.isValid = true
            }
    
            setDisableButton(disable)
        }
    }
      const multidest = watch("multidest")

useEffect(() => {
  if(bookingData?.current){
        let clist = Utils.getChargeList(JSON.parse(JSON.stringify(bookingData.current)))
        if(JSON.stringify(chargelist)!=JSON.stringify(clist)){
            setChargelist(clist)
        }
    }
            addlist()
            check()
            let unsubscribe = subscribe(taskStore.current, () => {
                check()
            })
            return unsubscribe
        }, [JSON.stringify(taskStore.current),JSON.stringify(multidest),bookingsStore.current,JSON.stringify(containerDetails)])

  let scope = watch("scope")
  const checkCountry = async (address, country, type, label) => {
    if ((scope.split('-')[0] == 'Port') && (type == 'Origin')) {
      address = address?.slice(address.lastIndexOf("(") + 1, address.length - 1).substring(0, 2)
    }
    if ((scope.split('-')[2] == 'Port') && (type == 'Destination')) {
      address = address?.slice(address.lastIndexOf("(") + 1, address.length - 1).substring(0, 2)
    }
    if ((scope.split('-')[0] == 'Door') && (type == 'Origin')) {
      const data = await MonApi.apost(GET_ADDRESSDETAILS_BY_FILTER_URI, {
  _id: address
})
      address = data[0]?.countryCode
    }
    if ((scope.split('-')[2] == 'Door') && (type == 'Destination')) {
      const data = await MonApi.apost(GET_ADDRESSDETAILS_BY_FILTER_URI, {
  _id: address
})
      address = data[0]?.countryCode
    }
    country = country?.slice(country.lastIndexOf("(") + 1, country.length - 1).substring(0, 2)
    console.log("🚀 ~ checkCountry ~ country:", country)
    console.log("🚀 ~ checkCountry ~ address:", address)
      
    if (address == country) {
      setObj(prev => ({ ...prev, [label]: true }));
    } else {
      setObj(prev => ({ ...prev, [label]: false }));
    }
  }

  const getDataForDSR = (booking,obj)=>{
    obj.shipmentScope = booking.shipmentScope
    obj.por = booking.portOfReceipt.slice(booking.portOfReceipt.lastIndexOf('(') + 1, booking.portOfReceipt.lastIndexOf(')'))
    obj.pol = booking.portOfLoading.slice(booking.portOfLoading.lastIndexOf('(') + 1, booking.portOfLoading.lastIndexOf(')'))
    obj.pod = booking.portOfDischarge.slice(booking.portOfDischarge.lastIndexOf('(') + 1, booking.portOfDischarge.lastIndexOf(')'))
    obj.fpod = booking.finalPlaceOfDelivery.slice(booking.finalPlaceOfDelivery.lastIndexOf('(') + 1, booking.finalPlaceOfDelivery.lastIndexOf(')'))
    obj.reworkingPort = booking?.reworkingPort?.slice(booking?.reworkingPort.lastIndexOf('(') + 1, booking?.reworkingPort.lastIndexOf(')'))
    return obj
  }
const getShipmentScope = (scope) => {
    const data = scope.split('-')
    if (data[0] === 'Port' && data[2] === 'Port') {
      return ['Port-to-Port', 'Port-to-Door']
    } else if (data[0] === 'Door' && data[2] === 'Port') {
      return ['Door-to-Port', 'Door-to-Door']
    } else {
      return []
    }
  }
  const destination = watch("multidest")

  const getUNCodeFromLocationString = (locString) =>{
    if(locString==undefined){
      return ""
    }else{
      return locString
      .trim()
      .slice(locString.lastIndexOf("(") + 1, locString.length - 1)
      .trim();
    }
    }
  let data = {
    'multidest': watch('multidest'), "volumeInDimensions":watch("volumeInDimensions")===undefined?true:watch("volumeInDimensions"),'fba': watch('isFba') == true ? 'Yes' : 'No', 'fbaIorRequired': watch('ior') == true ? 'Yes' : 'No', 'shipmentScope': watch('scope'), 'fbaOCC': watch('occ') == true ? 'Yes' : 'No', 'fbaDCC': watch('dcc') == true ? 'Yes' : 'No', 'opal':watch('opal'),'dpal':watch('dpal'),'fbaSurvey': watch('survey') == true ? 'Yes' : 'No', 'fbaSAD': watch('storageAtDestination') == true ? 'Yes' : 'No', 'fbaPAL': watch('palletizationandlabelling') == true ? 'Yes' : 'No',
    'cargoList': watch('cargoDetails'), 'containerList': containerDetails, 'cargoDimensionUnit': watch('cargoDimensionUnit'), 'hazardous': watch('hazardous') == true ? 'Yes' : 'No', 'nonStackable': watch('nonStackable') == true ? 'Yes' : 'No', 'stuffingType': watch('stuffingType'), 'destuffingType': watch('destuffingType'), 'fbaDays': watch('days'),'topLoading':watch('topLoading')== true ? 'Yes' : 'No',
    'temperatureControlled': watch('temperatureControlled') == true ? 'Yes' : 'No', 'portOfLoading': '', 'portOfDischarge': '', 'portOfReceipt': '', 'finalPlaceOfDelivery': '','reworkingPort':'','shipmentType':watch('shipmentType'),'fumigation':watch('fumigation')== true ? 'Yes' : 'No','headLoad':watch('headLoad')== true ? 'Yes' : 'No','doorLoad':watch('doorLoad')== true ? 'Yes' : 'No',
    'packingGroup': watch('packingGroup'), 'quoteClass': watch('quoteClass'), 'unnumber': watch('unnumber'), 'minTemperature': watch('minTemperature'), 'maxTemperature': watch('maxTemperature'), 'temperature': watch('temperature'), 'pick_up_by_amazon': watch('pick_up_by_amazon') == true ? 'Yes' :'No','cargoValue':watch('cargoValue'),'warehouse':watch('warehouse'),"iorParty":watch("iorParty")
  }
  useEffect(()=>{
      if(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0){
          setValue("cartingorder",true)
      }
  },[bookingsStore.current])

  useEffect(()=>{
    return ()=>{
      quoteDataRec.intialize()
    }
  },[])

  
  return (
    <>
      {
        (stage == 1) ? <>
          <p className="text-lg font-bold">Original Booking</p>
          <div className="flex flex-row gap-[10px]">
            <Route form={oldCargoForm} viewonly={true} />
            <Details form={oldCargoForm} viewonly={true} applyDefault={''} />
          </div>
          <div className="card-content">
            <div className="content">
              <div className="columns">
                <div className="column">
                  <AgTextShow
                    label="Place of Receipt"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.portOfReceipt
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Port of Loading"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.portOfLoading
                    )}
                  />
                </div>
                {taskStore.current.shipmentType.toUpperCase().indexOf('LCL') >= 0 && <div className="column ">
                  <AgTextShow
                    label="Reworking Port"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.reworkingPort
                    )}
                  />
                </div>}
                <div className="column">
                  <AgTextShow
                    label="Port of Discharge"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.portOfDischarge
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Final Place of Delivery"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.finalPlaceOfDelivery
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg font-bold">Revised Booking</p>
          <div className="flex flex-row gap-[10px]">
            <Route form={newCargoForm} viewonly={true} />
            <Details form={newCargoForm} viewonly={true} applyDefault={''} />
          </div>
          <div className="card-content">
            <div className="content">
              <div className="columns">
                <div className="column">
                  <AgTextShow
                    label="Place of Receipt"
                    value={getUNCodeFromLocationString(
                      task.por
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Port of Loading"
                    value={getUNCodeFromLocationString(
                      task.pol
                    )}
                  />
                </div>
                {taskStore.current.shipmentType.toUpperCase().indexOf('LCL') >= 0 && <div className="column ">
                  <AgTextShow
                    label="Reworking Port"
                    value={getUNCodeFromLocationString(
                      task.reworkingPort
                    )}
                  />
                </div>}
                <div className="column">
                  <AgTextShow
                    label="Port of Discharge"
                    value={getUNCodeFromLocationString(
                      task.pod
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Final Place of Delivery"
                    value={getUNCodeFromLocationString(
                      task.fpod
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          {(taskStore.current.changesRequired == true) ? <>
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('LCL') >= 0) ?
                <><h1>Orginal Cost</h1>
                  <ActChargesView chargelist={taskStore.current.oldchargesList} name={'originalCost'} />
                  <hr />
                  <h1>Revised Cost</h1>
                  <ActChargesView chargelist={taskStore.current.newchargeList} total={true} name={'revisedCost'} /></> :
                <></>
            }
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('AIR') >= 0) ?
                <><h1>Orginal Cost</h1>
                  <ActChargesAirView chargelist={taskStore.current.oldchargesList} name={'originalCost'} />
                  <hr />
                  <h1>Revised Cost</h1>
                  <ActChargesAirView chargelist={taskStore.current.newchargeList} total={true} name={'revisedCost'} /></> :
                <></>
            }
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('FCL') >= 0) ?
                <><h1>Orginal Cost</h1>
                  <ActFCLChargesView chargelist={taskStore.current.oldchargesList} container={bookingsStore.current.contract.containerList} name={'originalCost'} />
                  <hr />
                  <h1>Revised Cost</h1>
                  <ActFCLChargesView chargelist={taskStore.current.newchargeList} container={taskStore.current.newContract.containerList} total={true} name={'revisedCost'} /></> :
                <></>
            }
          </> : <></>}

          {
            (taskStore.current.showModal) ? <ActrejectModal /> : <></>
          }

          {
            (taskStore.current.files.length > 0 && !taskStore.current.approvalRequired) ? <>
              <hr />
              <Taskfiletable />
            </> : ""
          }
          <p >
            <button className="button islink"
              onClick={async (e) => {
                if (taskStore.current.approvalRequired) {
                taskStore.current.stage = 3
                taskStore.current.pendingWith = 'CUSTOMER'
                } else {
                taskStore.current.stage = 4
                taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                let cargo = []
                let multidest_new = []
                data.multidest.forEach((e, i) => {
                  let z = {}
                  z['destination'] = e.destination
                  z['cargoDetails'] = []
                  for (let j = 0; j < e.cargoDetails.length; j++) {
                      let k = e.cargoDetails[j]
                      k = Utils.setCargo_unit(k,e.cargoDetails[0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                    let c = Utils.convert_calcCargoDetails(e.cargoDetails[j], scope, bookingsStore.current.contract.shipmentType, false, bookingsStore.current.contract.cargoDimensionUnit, data.volumeInDimensions, bookingsStore?.current?.contract?.isCarting)
                      z['cargoDetails'].push(c)
                      cargo.push(c)
                  }
                  multidest_new.push(z)
                  taskStore.current.newContract.cargoList = JSON.parse(JSON.stringify(cargo))
                });
                taskStore.current.newContract.orginalMD = multidest_new
                if(taskStore.current?.newContract?.fba == "Yes" && bookingsStore.current?.fba == "No"){
                  taskStore.current.fbaDetails = Utils.fbaDetails(taskStore.current.newContract)
                }
                if(taskStore.current.changesRequired){
                  let usd = configStore.getExchangeRate('USD')
                  if (!usd) usd = 1.0
                  taskStore.current.newContract.quoteValue = Utils.R2(taskStore.current.total)
                  taskStore.current.newContract.quoteValueUSD = Utils.R2(taskStore.current.total / usd)
                  // taskStore.current.newContract.chargesList = taskStore.current.newchargeList
                  if(bookingsStore.current.createdFromPricing||bookingsStore.current.contractNum == 'SPOT' || (bookingsStore.current.cartingsheetId!=undefined && bookingData.cartingsheetId.length>0)){
                            let clist = []
                            let slist = []
                            let cnlist = []
                            let nl = JSON.parse(JSON.stringify(taskStore.current.newchargeList))
                            for (let i = 0; i < nl.length; i++) {
                                nl[i]['isIncluded'] = 'Yes'
                                if(nl[i]['onaccount']=='On Your Account'){
                                    clist.push(nl[i])
                                }else if(nl[i]['onaccount']==`Shipper's Account`){
                                    slist.push(nl[i])
                                }else{
                                    cnlist.push(nl[i])
                                }
                            }
                            taskStore.current.newContract.chargesList = clist
                            taskStore.current.newContract.shipperchargesList = slist
                            taskStore.current.newContract.consigneechargesList = cnlist
                  }else{
                      taskStore.current.newContract.chargesList = taskStore.current.newchargeList
                  }
                  let k = new QuoteCalcV2(taskStore.current.newContract).recalc()
                  taskStore.current.newContract.quoteValue =  k.quoteValue
                  taskStore.current.newContract.quoteValueUSD = k.quoteValueUSD
                }
                taskStore.setComplete()
                taskStore.current.stageStatus = 'Approve'
                await Api.updateBookingAmendment(taskStore.current)
                }
                await Taskapi.updateTask(taskStore.current)                 
                  BookingsApi.getBooking(bookingsStore.current._id, (data) => {
                  quoteDataRec.intialize()
                  contractsStore.current = data.contract
                  contractsStore.current = new QuoteCalcV2(contractsStore.current).recalc()
                  enquiryStore.initializeWithConract(data.contract)
                }) 
                taskStore.triggerActionVisible = false
                taskStore.myActionVisible = false
                if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
                  AgmodalStore.modalPage = ""
                  AgmodalStore.pageVisible = false
                  AgmodalStore.apiCall = true
              }
              }}>Accept</button>
            <button className="button islink"
              onClick={async (e) => {
                taskStore.current.stageStatus = 'Reject'
                taskStore.current.rejectedBy = loginStore.userRec.firstName + '' + loginStore.userRec.lastName + '(' + loginStore.email + ')'
                taskStore.current.showModal = true
              }}>Reject</button>
          </p></> : <></>
      }
{
        (stage == 3) ? <>
          <p className="text-lg font-bold">Original Booking</p>
          <div className="flex flex-row gap-[10px]">
            <Route form={oldCargoForm} viewonly={true} />
            <Details form={oldCargoForm} viewonly={true} applyDefault={''} />
          </div>
          <div className="card-content">
            <div className="content">
              <div className="columns">
                <div className="column">
                  <AgTextShow
                    label="Place of Receipt"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.portOfReceipt
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Port of Loading"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.portOfLoading
                    )}
                  />
                </div>
                {taskStore.current.shipmentType.toUpperCase().indexOf('LCL') >= 0 && <div className="column ">
                  <AgTextShow
                    label="Reworking Port"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.reworkingPort
                    )}
                  />
                </div>}
                <div className="column">
                  <AgTextShow
                    label="Port of Discharge"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.portOfDischarge
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Final Place of Delivery"
                    value={getUNCodeFromLocationString(
                      bookingsStore.current.contract.finalPlaceOfDelivery
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

          <p className="text-lg font-bold">Revised Booking</p>
          <div className="flex flex-row gap-[10px]">
            <Route form={newCargoForm} viewonly={true} />
            <Details form={newCargoForm} viewonly={true} applyDefault={''} />
          </div>
          <div className="card-content">
            <div className="content">
              <div className="columns">
                <div className="column">
                  <AgTextShow
                    label="Place of Receipt"
                    value={getUNCodeFromLocationString(
                      task.por
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Port of Loading"
                    value={getUNCodeFromLocationString(
                      task.pol
                    )}
                  />
                </div>
                {taskStore.current.shipmentType.toUpperCase().indexOf('LCL') >= 0 && <div className="column ">
                  <AgTextShow
                    label="Reworking Port"
                    value={getUNCodeFromLocationString(
                      task.reworkingPort
                    )}
                  />
                </div>}
                <div className="column">
                  <AgTextShow
                    label="Port of Discharge"
                    value={getUNCodeFromLocationString(
                      task.pod
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Final Place of Delivery"
                    value={getUNCodeFromLocationString(
                      task.fpod
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          {(taskStore.current.changesRequired == true) ? <>
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('LCL') >= 0) ?
                <><h1>Orginal Cost</h1>
                  <ActChargesView chargelist={taskStore.current.oldchargesList} name={'originalCost'} />
                  <hr />
                  <h1>Revised Cost</h1>
                  <ActChargesView chargelist={taskStore.current.newchargeList} total={true} name={'revisedCost'} /></> :
                <></>
            }
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('AIR') >= 0) ?
                <><h1>Orginal Cost</h1>
                  <ActChargesAirView chargelist={taskStore.current.oldchargesList} name={'originalCost'} />
                  <hr />
                  <h1>Revised Cost</h1>
                  <ActChargesAirView chargelist={taskStore.current.newchargeList} total={true} name={'revisedCost'} /></> :
                <></>
            }
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('FCL') >= 0) ?
                <><h1>Orginal Cost</h1>
                  <ActFCLChargesView chargelist={taskStore.current.oldchargesList} container={bookingsStore.current.contract.containerList} name={'originalCost'} />
                  <hr />
                  <h1>Revised Cost</h1>
                  <ActFCLChargesView chargelist={taskStore.current.newchargeList} container={bookingsStore.current.contract.containerList} total={true} name={'revisedCost'} /></> :
                <></>
            }
          </> : <></>}

          {
            (taskStore.current.showModal) ? <ActrejectModal /> : <></>
          }

          {
            (taskStore.current.files.length > 0 && !taskStore.current.approvalRequired) ? <>
              <hr />
              <Taskfiletable />
            </> : ""
          }
          <p >
            <button className="button islink"
              onClick={async (e) => {
                taskStore.current.stage = 4
                taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
                let cargo = []
                let multidest_new = []
                data.multidest.forEach((e, i) => {
                  let z = {}
                  z['destination'] = e.destination
                  z['cargoDetails'] = []
                  for (let j = 0; j < e.cargoDetails.length; j++) {
                      let k = e.cargoDetails[j]
                      k = Utils.setCargo_unit(k,e.cargoDetails[0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                    let c = Utils.convert_calcCargoDetails(e.cargoDetails[j], scope, bookingsStore.current.contract.shipmentType, false, bookingsStore.current.contract.cargoDimensionUnit, data.volumeInDimensions, bookingsStore?.current?.contract?.isCarting)
                      z['cargoDetails'].push(c)
                      cargo.push(c)
                  }
                  multidest_new.push(z)
                  taskStore.current.newContract.cargoList = JSON.parse(JSON.stringify(cargo))
                });
                taskStore.current.newContract.orginalMD = multidest_new
                if(taskStore.current.newContract.fba == 'Yes' && (bookingsStore.current.fba=='No' || (bookingsStore.current.fba=='Yes' && bookingsStore.current.contract?.warehouse == 'WALMART')) && taskStore.current.newContract.warehouse == 'AMAZON'){
                  taskStore.current.fbaDetails = Utils.fbaDetails(taskStore.current.newContract)
                }
                if(taskStore.current.changesRequired){
                  let usd = configStore.getExchangeRate('USD')
                  if (!usd) usd = 1.0
                  taskStore.current.newContract.quoteValue = Utils.R2(taskStore.current.total)
                  taskStore.current.newContract.quoteValueUSD = Utils.R2(taskStore.current.total / usd)
                  // taskStore.current.newContract.chargesList = taskStore.current.newchargeList
                  if(bookingsStore.current.createdFromPricing||bookingsStore.current.contractNum == 'SPOT' || (bookingsStore.current.cartingsheetId!=undefined && bookingData.cartingsheetId.length>0)){
                            let clist = []
                            let slist = []
                            let cnlist = []
                            let nl = JSON.parse(JSON.stringify(taskStore.current.newchargeList))
                            for (let i = 0; i < nl.length; i++) {
                                nl[i]['isIncluded'] = 'Yes'
                                if(nl[i]['onaccount']=='On Your Account'){
                                    clist.push(nl[i])
                                }else if(nl[i]['onaccount']==`Shipper's Account`){
                                    slist.push(nl[i])
                                }else{
                                    cnlist.push(nl[i])
                                }
                            }
                            taskStore.current.newContract.chargesList = clist
                            taskStore.current.newContract.shipperchargesList = slist
                            taskStore.current.newContract.consigneechargesList = cnlist
                        }else{
                            taskStore.current.newContract.chargesList = taskStore.current.newchargeList
                        }
                  let k = new QuoteCalcV2(taskStore.current.newContract).recalc()
                  taskStore.current.newContract.quoteValue =  k.quoteValue
                  taskStore.current.newContract.quoteValueUSD = k.quoteValueUSD
                }
                taskStore.setComplete()
                taskStore.setCustomerComplete()
                taskStore.current.stageStatus = 'Approve'
                Api.updateBookingAmendment(taskStore.current)
                await Taskapi.updateTask(taskStore.current)
                BookingsApi.getBooking(bookingsStore.current._id, (data) => {
                  quoteDataRec.intialize()
                  contractsStore.current = data.contract
                  contractsStore.current = new QuoteCalcV2(contractsStore.current).recalc()
                  enquiryStore.initializeWithConract(data.contract)
                })
                taskStore.triggerActionVisible = false
                taskStore.myActionVisible = false
                if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
                  AgmodalStore.pageVisible = false
                  AgmodalStore.apiCall = true
                }
              }}>Accept</button>
            <button className="button islink"
              onClick={async (e) => {
                taskStore.current.stageStatus = 'Reject'
                taskStore.current.rejectedBy = loginStore.userRec.firstName + '' + loginStore.userRec.lastName + '(' + loginStore.email + ')'
                taskStore.current.showModal = true
              }}>Reject</button>
          </p></> : <></>
      }

      {
        (stage == 2)?<>
        <div>
              { taskStore.current?.rejectedBy && <p>The action has been rejected by <strong>{task.rejectedBy}</strong>. Please see reason below.</p>}
              <h1><strong>Reject Reason : </strong>{taskStore.current.rejectReason}</h1>
          </div>
          <hr />
        <div className="flex flex-row gap-[10px] mt-3">
        <AgRoute form={newCargoForm} viewonly={false} callback={''} currentShipmentScopes={getShipmentScope(bookingsStore.current.contract.shipmentScope)} />
        <Details form={newCargoForm} viewonly={false} applyDefault={false} sd={true} />
      </div>
        <Card className="qoutecard mt-2">
          <div style={{ display: "flex", paddingLeft: "15px" }}>
            <span><img src={ship1} /></span><Headspan
              color="#00000" fontSize="14px" fontWeight="900" data=" Port  Details" />
          </div>
          <div class="columns is-vcentered is-multiline m-1">
            <Col3>
              <AgUnloc
                {..._params(portOfReceiptLable, "por")}
                isValid={obj.portOfReceipt}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, portOfReceipt: list.some(ele => ele === value) })))
                  taskStore.current.por = value
                  checkCountry(taskStore.current.origin, taskStore.current.por, "Origin", "portOfReceipt")

                }}
              />

            </Col3>
            <Col3>
              <AgUnloc
                {..._params(portOfLoadingLabel, "pol")}
                isValid={obj.portOfLoading}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, portOfLoading: list.some(ele => ele === value) })))
                  taskStore.current.pol = value
                  checkCountry(taskStore.current.origin, taskStore.current.pol, "Origin", "portOfLoading")

                }}
              />
            </Col3>
            {taskStore.current.newContract.shipmentType.indexOf("LCL") !== -1 &&
            <Col3>
              <AgUnloc
                {..._params('Reworking Port', "reworkingPort")}
                isValid={
                  obj["reworkingPort"]
                }
                callback={(value, list) => {
                  taskStore.current.reworkingPort = value
                }}
              />
            </Col3>}
            <Col3>
              <AgUnloc
                {..._params(portOfDischargeLabel, "pod")}
                isValid={obj.portOfDischarge}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, portOfDischarge: list.some(ele => ele === value) })))
                  taskStore.current.pod = value
                  checkCountry(destination[0].destination, taskStore.current.pod, "Destination", "portOfDischarge")

                }}
              />
            </Col3>
            <Col3>
              <AgUnloc
                {..._params("Final Place of Delivery", "fpod")}
                isValid={obj.finalPlaceOfDelivery}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, finalPlaceOfDelivery: list.some(ele => ele === value) })))
                  taskStore.current.fpod = value
                  checkCountry(destination[0].destination, taskStore.current.fpod, "Destination", 'finalPlaceOfDelivery')

                }}
                validationMsg="- Please select enter valid UN location."
              />
            </Col3>

          </div></Card>
        <div className="flex flex-row gap-[10px]">
          <p className="text-lg font-bold">Charges Amendment</p>
          <AntSwitch className="mt-1" checked={view} onChange={(e) => {
            setView(!view)
            if (!e.target.checked) {
              taskStore.current.approvalRequired = false
            }
          }} />
        </div>
        {view ? <> <div>
          {
            (taskStore.current.newContract.shipmentType.toUpperCase().indexOf('LCL') >= 0) ?
              <><p className="text-lg font-bold">Orginal Cost</p>
                    <ActChargesView chargelist={taskStore.current.oldchargesList.length>0?taskStore.current.oldchargesList:contractsStore.current.chargesList} name={'originalCost'} />
                    <hr/>
                    <p className="text-lg font-bold">Revised Cost</p>
                    <ActChargesComp  data={scope} /> </>:
                    <></>
          }
          {
            (taskStore.current.newContract.shipmentType.toUpperCase().indexOf('AIR') >= 0) ?
              <><p className="text-lg font-bold">Orginal Cost</p>
                <ActChargesAirView chargelist={taskStore.current.oldchargesList.length>0?taskStore.current.oldchargesList:contractsStore.current.chargesList} name={'originalCost'}  />
                <hr />
                <p className="text-lg font-bold">Revised Cost</p>
                <ActChargesAirComp  data={scope} /></> :
                    <></>
          }
          {
            (taskStore.current.newContract.shipmentType.toUpperCase().indexOf('FCL') >= 0) ?
              <><p className="text-lg font-bold">Orginal Cost</p>
                 <ActFCLChargesView chargelist={taskStore.current.oldchargesList.length>0?taskStore.current.oldchargesList:contractsStore.current.chargesList} container={bookingsStore.current.contract.containerList} name={'originalCost'} />
                 <hr />
                 <p className="text-lg font-bold">Revised Cost</p>
                  <ActFCLChargesComp  data={scope} /></> :
                  <></>
          }
        </div>
          <div className="flex flex-row gap-[10px]">
            <p className="text-lg font-bold">Approval Required</p>
            <AntSwitch className="mt-1" checked={taskStore.current.approvalRequired} onChange={(e) => {
              taskStore.current.approvalRequired = e.target.checked
            }} />
          </div></>
          : <></>}
      
      {
        (taskStore.current.shipmentType == 'LCL') ?
          <Taskfiletable /> : <></>
      }
      <p>
        <button className="button islink float-end" onClick={async (e)=>{
        //  console.log(taskStore.current,"changes",data);
        //  console.log(" the place found is ",data.iorParty)
         console.log(" the console of the volume in dimensions ",getValuesNewForm("volumeInDimensions"))
         for (let key in data) {
            if (data[key] === undefined || data[key] === "") {
              delete data[key];
            }
            if (bookingsStore.current.contract[key] === undefined && data[key] === 'No') {
                delete data[key];
            }
          }
          let dsrObj={}
          data.multidest.forEach((e, i) => {
            const key = i === 0 ? 'destination' : `destination${i + 1}`;
            data[key] = e.destination;
            dsrObj[key] = e.destination;
          });
          data.portOfReceipt = taskStore.current.por
          data.portOfDischarge = taskStore.current.pod
          data.portOfLoading = taskStore.current.pol
          data.finalPlaceOfDelivery = taskStore.current.fpod
          data.reworkingPort = taskStore.current.reworkingPort
          taskStore.current.bookingDSR = getDataForDSR(data,dsrObj) 
          taskStore.current.changesRequired = view
          taskStore.current.stageStatus = 'Approve'
          taskStore.current.newContract.volumeInDimensions = getValuesNewForm("volumeInDimensions") ?? true;
         
           let cargo =[]
            let multidest_new = []
            data.multidest.forEach((e, i) => {
                  let z = {}
                  z['destination'] = e.destination
                  z['cargoDetails'] = []
                  for (let j = 0; j < e.cargoDetails.length; j++) {
                      let k = e.cargoDetails[j]
                      console.log("🚀 ~ k:", k)
                      k = Utils.setCargo_unit(k,e.cargoDetails[0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                    let c = Utils.convert_calcCargoDetails(e.cargoDetails[j], scope, bookingsStore.current.contract.shipmentType, false, bookingsStore.current.contract.cargoDimensionUnit, data.volumeInDimensions, bookingsStore?.current?.contract?.isCarting)
                      z['cargoDetails'].push(c)
                      cargo.push(c)
                  }
                  multidest_new.push(z)
                  console.log(" the cargo for multidest is ",cargo)
                data['cargoList'] = cargo
            });
          taskStore.current.newContract.cargoList = data['cargoList']
          taskStore.current.newContract = JSON.parse(JSON.stringify(data))
          taskStore.current.newContract['cargoTotals'] = new QuoteCalcV2(taskStore.current.newContract).calculateCargoTotals(taskStore.current.newContract.cargoList)
          console.log(" the total cargo list is ",taskStore.current.newContract['cargoTotals'])
          const isValid = await trigger();
          console.log("🚀 ~ <buttonclassName=onClick={ ~ isValid:", isValid)
          const allTrue = Object.values(obj).every(val => val === true);
          console.log("🚀 ~ <buttonclassName=onClick={ ~ allTrue:", allTrue)
          if(isValid && allTrue && !disableButton ){
              let newchargeList = []
            if (taskStore.current.changesRequired) {
              taskStore.current.oldchargesList = chargelist
          //     if(taskStore.current.oldchargesList!=undefined && taskStore.current.oldchargesList.length>0){
          //     newchargeList = JSON.parse(JSON.stringify(taskStore.current.oldchargesList))
          // }else{
              taskStore.current.chargesList = taskStore.current.chargesList.filter(e => e.chargeDescription)
              newchargeList = JSON.parse(JSON.stringify(taskStore.current.chargesList))
          // }
          let c = taskStore.current.chargesList
          let booking = bookingsStore.current
          // for (let i = 0; i < c.length; i++) {
          //     c[i]['id']=booking.contract.chargesList.length+1
          //     newchargeList.push(c[i])
          // }
          taskStore.current.newchargeList = JSON.parse(JSON.stringify(newchargeList))
             }else{
              taskStore.current.changesRequired = false
              taskStore.current.approvalRequired = false
             }
             if (bookingsStore.current.contract.shipmentType != 'LCL' && taskStore.current.changesRequired && !taskStore.current.approvalRequired && taskStore.current.files.length > 0) {
               taskStore.current.files[0].label = "Supporting Document"
             }
             if(bookingsStore.current.contract.shipmentType != 'LCL' && !taskStore.current.changesRequired ){
                taskStore.current.files = []
             }
             console.log(!taskStore.current.approvalRequired ,bookingsStore.current.contract.shipmentType == 'LCL' , !taskStore.current.files.some(e=>e.label == 'Supporting Document' ) , taskStore.current.changesRequired,"0000000000000000333333333");
             
             if (!taskStore.current.approvalRequired && bookingsStore.current.contract.shipmentType == 'LCL' && !taskStore.current.files.some(e=>e.label == 'Supporting Document' ) && taskStore.current.changesRequired ) {
               taskStore.current.files.push({ "label": "Supporting Document", "filename": "", "invoiceNo": "", "invoiceDate": "", "approved": "", "rejectReason": "" })
             }          
          taskStore.current.stage = 1
          taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
          // return;
          await Taskapi.updateTask(taskStore.current)
          taskStore.triggerActionVisible = false
          taskStore.myActionVisible = false
          if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
            AgmodalStore.pageVisible = false
            AgmodalStore.apiCall = true
          }
          }else{
            taskStore.current.isValid = false
            configStore.setModalMessage(
              `Please check the fields`
            )
          }
        }}>
        Submit
        </button>
      </p>
        </>:<></>
      }


      {
        (stage > 3) ? <>
          <p className="text-lg font-bold">Revised Booking</p>
          <div className="flex flex-row gap-[10px]">
            <Route form={newCargoForm} viewonly={true} />
            <Details form={newCargoForm} viewonly={true} applyDefault={''} />
          </div>
          <div className="card-content">
            <div className="content">
              <div className="columns">
                <div className="column">
                  <AgTextShow
                    label="Place of Receipt"
                    value={getUNCodeFromLocationString(
                      taskStore.current.por
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Port of Loading"
                    value={getUNCodeFromLocationString(
                      taskStore.current.pol
                    )}
                  />
                </div>
                {taskStore.current.newContract.shipmentType.indexOf("LCL") !== -1 && <div className="column ">
                  <AgTextShow
                    label="Reworking Port"
                    value={getUNCodeFromLocationString(
                      taskStore.current.reworkingPort
                    )}
                  />
                </div>}
                <div className="column">
                  <AgTextShow
                    label="Port of Discharge"
                    value={getUNCodeFromLocationString(
                      taskStore.current.pod
                    )}
                  />
                </div>
                <div className="column ">
                  <AgTextShow
                    label="Final Place of Delivery"
                    value={getUNCodeFromLocationString(
                      taskStore.current.fpod
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
          {(taskStore.current.changesRequired == true) ? <>
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('LCL') >= 0) ?
              <><h1>Revised Cost</h1>
                  <ActChargesView chargelist={taskStore.current.newchargeList} total={true} name={'revisedCost'} /></> :
                <></>
            }
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('AIR') >= 0) ?
                <><h1>Revised Cost</h1>
                  <ActChargesAirView chargelist={taskStore.current.newchargeList} total={true} name={'revisedCost'} /></> :
                <></>
            }
            {
              (taskStore.current.shipmentType.toUpperCase().indexOf('FCL') >= 0) ?
                <><h1>Revised Cost</h1>
                  <ActFCLChargesView chargelist={taskStore.current.newchargeList} container={bookingsStore.current.contract.containerList} total={true} name={'revisedCost'} /></> :
                <></>
            }
          </> : <></>}

          {
            (taskStore.current.showModal) ? <ActrejectModal /> : <></>
          }
        </> : <></>
      }
    </>
  )


}
export function BookingAmendmentTrigger(props) {
  useSnapshot(QuotationValidationStore);
  useSnapshot(cargoStore)
  useSnapshot(containerStore)
  let bookingData = useSnapshot(bookingsStore)
  const [chargelist, setChargelist] = useState([])
  const [show, setShow] = useState(false);
  const [view, setView] = useState(false);
  const [disableButton, setDisableButton] = useState(true)
  const [obj, setObj] = useState({ portOfReceipt: true, portOfLoading: true, portOfDischarge: true, finalPlaceOfDelivery: true,reworkingPort:true })

  const _params = (label, name, type = "text", dataList = []) => {
    return {
      type,
      name,
      label,
      record: taskStore.current,
      dataList,
    };
  };
  const portOfReceiptLable =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of Receipt"
      : "Place of Receipt";
  const portOfLoadingLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of departure"
      : "* Port of Loading";
  const portOfDischargeLabel =
    quoteDataRec.shipmentType.indexOf("Air") >= 0
      ? "* Airport of Arrival"
      : "Port of Discharge";

  const cargoForm = useForm({
    defaultValues: {
      mode: "LCL",
      orginScope: false,
      destinationScope: false,
      originType: false,
      destinationType: false,
      showCargoDetailsOutGuage: false,
      showPalletLabel: false,
    }
  })
  const { control, watch, register, setValue, handleSubmit, reset, getValues,clearErrors, formState, trigger, getFieldState } = cargoForm;
  const isFba = watch("isFba");
  const destination = watch("multidest")
  let keys = ['multidest', 'isFba', 'ior', 'shipmentScope', 'occ', 'dcc', 'survey', 'storageAtDestination',
    'cargoDetails', 'containerDetails', 'cargoDimensionUnit', 'hazardous', 'nonStackable', 'stuffingType', 'destuffingType',
    'temperatureControlled'
  ]
  let data = {
    'multidest': destination, "volumeInDimensions":watch("volumeInDimensions")===undefined?true:watch("volumeInDimensions"),'fba': watch('isFba') == true ? 'Yes' : 'No', 'fbaIorRequired': watch('ior') == true ? 'Yes' : 'No', 'shipmentScope': watch('scope'), 'fbaOCC': watch('occ') == true ? 'Yes' : 'No', 'fbaDCC': watch('dcc') == true ? 'Yes' : 'No','opal':watch('opal'),'dpal':watch('dpal'), 'fbaSurvey': watch('survey') == true ? 'Yes' : 'No', 'fbaSAD': watch('storageAtDestination') == true ? 'Yes' : 'No', 'fbaPAL': watch('palletizationandlabelling') == true ? 'Yes' : 'No',
    'cargoList': watch('cargoDetails'), 'containerList': sortObjectKeys(watch('containerDetails')), 'cargoDimensionUnit': watch('cargoDimensionUnit'), 'hazardous': watch('hazardous') == true ? 'Yes' : 'No', 'nonStackable': watch('nonStackable') == true ? 'Yes' : 'No', 'stuffingType': watch('stuffingType'), 'destuffingType': watch('destuffingType'), 'fbaDays': watch('days'),'topLoading':watch('topLoading')== true ? 'Yes' : 'No',
    'temperatureControlled': watch('temperatureControlled') == true ? 'Yes' : 'No', 'portOfLoading': '', 'portOfDischarge': '', 'portOfReceipt': '', 'finalPlaceOfDelivery': '','reworkingPort':'','shipmentType':watch('shipmentType'),'fumigation':watch('fumigation')== true ? 'Yes' : 'No','headLoad':watch('headLoad')== true ? 'Yes' : 'No','doorLoad':watch('doorLoad')== true ? 'Yes' : 'No',
    'packingGroup': watch('packingGroup'), 'quoteClass': watch('quoteClass'), 'unnumber': watch('unnumber'), 'minTemperature': watch('minTemperature'), 'maxTemperature': watch('maxTemperature'), 'temperature': watch('temperature'), 'pick_up_by_amazon': watch('pick_up_by_amazon') == true ? 'Yes' :'No','cargoValue':watch('cargoValue'),'warehouse':watch('warehouse'),"iorParty":watch("iorParty")
  }
  async function getFile(){
    if(bookingsStore.current.contract.shipmentType == 'LCL'){
    const file = await MonApi.apost(GET_MYACTIONS_MEASUREMENT_SLIP_URI, {
  bookingNum: bookingsStore.current._id
})
    if(file.length >0 ) taskStore.current.files = file[0].files
   }
  }

  useEffect(() => { 
    loader.show()
    getFile()
    return ()=>{
      quoteDataRec.intialize()
    }
   }, [])
  useEffect(() => {
    if (enquiryStore.current.enqRoute != undefined && enquiryStore.current.enqRoute.origin != undefined && enquiryStore.current.enqRoute.origin.length > 0) {
      reset({
        mode: "LCL",
        orginScope: false,
        destinationScope: false,
        originType: false,
        destinationType: false,
        showCargoDetailsOutGuage: false,
        showPalletLabel: false
      })
      if (enquiryStore.current.shipmentType.length > 3 && enquiryStore.current.shipmentType.toLowerCase().indexOf('fcl') != -1) {
        enquiryStore.current.shipmentType = 'FCL'
        setValue("mode", 'FCL');
      } else {
        setValue("mode", enquiryStore.current.shipmentType);
      }
      setValue("multidest", enquiryStore.current.multidest)
      setValue("containerDetails", enquiryStore.current.containerDetails)
      setValue("fbaalways", "Yes")
      setValue("warehouse",enquiryStore.current.warehouse)
      setValue("origin", enquiryStore.current.enqRoute.origin)
      setValue("cargoreadinessdate", enquiryStore.current.enqRoute.cargoReadinessDate)
      setValue("scope", enquiryStore.current.shipmentScope)
      setValue("shipmentType", enquiryStore.current.shipmentType)
      setValue("customerreference", enquiryStore.current.enqRoute.customerReferenceNum)
      setValue("hazardous", enquiryStore.current.hazardous === "No" ? false : true)
      setValue("quoteClass", enquiryStore.current.quoteClass)
      setValue("packingGroup", enquiryStore.current.packingGroup)
      setValue("temperature", enquiryStore.current.temperature)
      setValue("cargoValue", enquiryStore.current.cargoValue)
      setValue("unnumber", enquiryStore.current.unnumber)
      setValue("nonStackable", enquiryStore.current.nonStackable === "No" ? false : true)
      setValue("temperatureControlled", enquiryStore.current.temperatureControlled === "No" ? false : true)
      setValue("minTemperature", enquiryStore.current.minTemperature)
      setValue("maxTemperature", enquiryStore.current.maxTemperature)
      setValue("stuffingType", enquiryStore.current.stuffingType)
      setValue("destuffingType", enquiryStore.current.destuffingType)
      setValue("status", enquiryStore.current.status)
      setValue("cargoDimensionUnit", enquiryStore.current.cargoDimensionUnit)
      setValue("enqRoute", enquiryStore.current.enqRoute)
      setValue("vehicledetails", enquiryStore.current.vehicles)
      setValue("isFba", enquiryStore.current.fba === "Yes" ? true : false)
      setValue("ior", enquiryStore.current.fbaIorRequired === "Yes" ? true : false)
      setValue("iorParty",enquiryStore.current.iorParty)
      setValue("occ", enquiryStore.current.fbaOCC === "Yes" ? true : false)
      setValue("dcc", enquiryStore.current.fbaDCC === "Yes" ? true : false)
      setValue("opal",enquiryStore.current.opal)
      setValue("dpal",enquiryStore.current.dpal)
      setValue("survey", enquiryStore.current.fbaSurvey === "Yes" ? true : false)
      setValue("storageAtDestination", enquiryStore.current.fbaSAD === "Yes" ? true : false)
      setValue("palletizationandlabelling", enquiryStore.current.fbaPAL === "Yes" ? true : false)
      setValue("days", enquiryStore.current.fbaDays != undefined ? enquiryStore.current.fbaDays : 0)
      setValue("pick_up_by_amazon", enquiryStore.current.pick_up_by_amazon === "Yes" ? true : false)
      setValue("overHeight",enquiryStore.current.overHeight === "Yes" ? true :false)
      setValue("overlength",enquiryStore.current.overlength === "Yes" ? true :false)
      setValue("topLoading",enquiryStore.current.topLoading === "Yes" ? true :false)
      setValue("fumigation",enquiryStore.current.fumigation === "Yes" ? true :false)
      setValue("headLoad",enquiryStore.current.headLoad === "Yes" ? true :false)
      setValue("doorLoad",enquiryStore.current.doorLoad === "Yes" ? true :false)
      setValue("reefer",enquiryStore.current.reefer === "Yes" ? true :false)
      setValue("overHeightValue",enquiryStore.current.overHeightValue)
      setValue("overlengthValue",enquiryStore.current.overlengthValue)
      setValue("volumeInDimensions",enquiryStore.current.volumeInDimensions ?? true)
      // setValue("multidest",enquiryStore.current.multidest)
      setShow(true)
      loader.hide()
    }
  }, [enquiryStore.current])
  useEffect(()=>{
      if(bookingsStore.current.cartingsheetId!=undefined && bookingsStore.current.cartingsheetId.length>0){
          setValue("cartingorder",true)
      }
  },[bookingsStore.current])
  const getShipmentScope = (scope) => {
    const data = scope.split('-')
    if (data[0] === 'Port' && data[2] === 'Port') {
      return ['Port-to-Port', 'Port-to-Door']
    } else if (data[0] === 'Door' && data[2] === 'Port') {
      return ['Door-to-Port', 'Door-to-Door']
    } else {
      return []
    }
  }

  let stype = enquiryStore.current.shipmentType
  let key = ''
  if (stype.toUpperCase().indexOf('FCL') > -1) {
    key = 'FCL'
  } else if (stype.toUpperCase().indexOf('AIR') > -1) {
    key = 'AIR'
  } else {
    key = 'LCL'
  }
  let multidest = watch("multidest")
  let containerDetails = watch('containerDetails')
  function addlist() {
    if (taskStore.current.chargesList.length == 0) {
      switch (key) {
        case 'FCL':
          containerStore.list = bookingsStore.current.contract.containerList
          fclChargesStore.colNames = {
            twoSpan: '',
            twoSpan1: 'Per Container',
            twoSpan2: '',
            perShipment: 'Per BL'
          }
          fclChargesStore.initialLength = 0
          fclChargesStore.list = JSON.parse(JSON.stringify(chargelist))
          // [{
          //                 id: 1,
          //                 chargeDescription: '',
          //                 currency: 'INR'
          //             }]
          taskStore.current.chargesList = fclChargesStore.list
          break;
        case 'AIR':
          containerStore.list = bookingsStore.current.contract.containerList
          airChargesStore.initialLength = 0
          airChargesStore.list = JSON.parse(JSON.stringify(chargelist)) 
          // [
          //                 {
          //                     id: 1,
          //                     chargeDescription: '',
          //                     currency: 'INR'
          //                 }
          //             ]
          taskStore.current.chargesList = airChargesStore.list
          break;
        case 'LCL':
          chargesStore1.initialLength = 0
          chargesStore1.list = JSON.parse(JSON.stringify(chargelist)) 
          //  [
          //                 {
          //                     id: 1,
          //                     chargeDescription: '',
          //                     currency: 'INR',
          //                     perCBM: 0,
          //                     perTon: 0,
          //                     minimum: 0,
          //                     maximum: 0
          //                 }
          //             ]
          taskStore.current.chargesList = chargesStore1.list
          break;
      }
    }
  }

  function check() {
    let disable = false
    let cargo = []
    let multidest_new = []
    switch (key) {
      case 'FCL':
        let container =[]
          let obj1 = {}
              for (let j = 0; j < containerDetails?.length; j++) {
                if(containerDetails[j]['containerType']!=undefined && containerDetails[j]['containerType'].length>0){
                  let c = containerDetails[j]['containerType']
                  if(obj1[c]==undefined){
                      obj1[c] = {
                          containerType : "",
                          numContainers: 0,
                          unit: "",
                          wtPerContainer: 0
                      }
                  }
                  obj1[c]['containerType'] = c
                  obj1[c]['unit'] = 'Kgs'
                  obj1[c]['numContainers'] = obj1[c]['numContainers']+Number(containerDetails[j]['numContainers'])
                  obj1[c]['wtPerContainer'] = Number(Utils.toUnit(containerDetails[j]['wtPerContainer'], containerDetails[0]['unit']))
                }
              }
            let o = Object.keys(obj1)
            console.log("🚀 ~ check ~ o:", o)
            for (let i = 0; i < o.length; i++) {
                container.push(obj1[o[i]])
            }
            if(JSON.stringify(containerStore.list)!=JSON.stringify(container)){
                containerStore.list = JSON.parse(JSON.stringify(container))
              }
              if(JSON.stringify(containerStore.list)!=JSON.stringify(bookingsStore.current.contract.containerDetails)){
                  taskStore.current.chargesList = fclChargesStore.list
              }
           fclChargesStore.actcalculateChargesTotals(quoteDataRec.emptycontainerweight)
        taskStore.current.chargesList.map((e) => {
          if (e['chargeDescription'].length == 0 || e['currency'].length == 0) {
            disable = true
          }
          let a = false
          // containerDetails?.map((e1) => {
          //   if (!a) {
          //     if (e[e1['containerType'] + 'total'] != undefined) {
          //       if (e[e1['containerType'] + 'total'] == 0 && e['chargeDescription'] !='Marine Insurance') {
          //         disable = true
          //       } else {
          //         a = true
          //         disable = false
          //       }
          //     } else {
          //       disable = true
          //     }
          //   }
          // })
        })

        break;
      case 'AIR':
         cargo = []
           multidest_new = []
            for (let i = 0; i < data.multidest?.length; i++) {
              let z = {}
              z['destination'] = multidest[i]['destination']
              z['cargoDetails'] = []
              for (let j = 0; j < multidest[i]['cargoDetails'].length; j++) {
                let k = multidest[i]['cargoDetails'][j]
                k = Utils.setCargo_unit(k,multidest[0]['cargoDetails'][0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                let c = Utils.convert_calcCargoDetails(multidest[i]['cargoDetails'][j],scope,bookingsStore.current.contract.shipmentType,false,bookingsStore.current.contract.cargoDimensionUnit,data.volumeInDimensions)
                z['cargoDetails'].push(c)
                cargo.push(c)
              }
              multidest_new.push(z)
            }
        if(JSON.stringify(cargoStore.cargoList) != JSON.stringify(cargo)){
          cargoStore.cargoList = JSON.parse(JSON.stringify(cargo))
        }
        cargoStore.calculateCargoTotals()
        airChargesStore.actcalculateChargesTotals()
        taskStore.current.chargesList.map((e) => {
          if (e['chargeDescription'].length == 0 || e['currency'].length == 0) {
            disable = true
          }
          // if (e['total'] != undefined) {
          //   if (e['total'] == 0) {
          //     disable = true
          //   }
          // } else {
          //   disable = true
          // }
        })

        break;
      case 'LCL':
          cargo = []
         multidest_new = []
            for (let i = 0; i < data.multidest?.length; i++) {
              let z = {}
              z['destination'] = multidest[i]['destination']
              z['cargoDetails'] = []
              for (let j = 0; j < multidest[i]['cargoDetails'].length; j++) {
                let k = multidest[i]['cargoDetails'][j]
                k = Utils.setCargo_unit(k,multidest[0]['cargoDetails'][0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                let c = Utils.convert_calcCargoDetails(multidest[i]['cargoDetails'][j],scope,bookingsStore.current.contract.shipmentType,false,bookingsStore.current.contract.cargoDimensionUnit,data.volumeInDimensions)
                z['cargoDetails'].push(c)
                cargo.push(c)
              }
              multidest_new.push(z)
            }
        if (JSON.stringify(cargoStore.cargoList) != JSON.stringify(cargo)) {
          cargoStore.cargoList = JSON.parse(JSON.stringify(cargo))
        }
        cargoStore.calculateCargoTotals()
        chargesStore1.actcalculateChargesTotals()
        break;
    }

//     if (taskStore.current.chargesList.length == 0 || taskStore.current.chargesList.some(e => e.chargeDescription === '' || e.onaccount=='' ||
//         (e.hasOwnProperty('total') && (e.total == '') ||
//        !Object.keys(e).some(key => key.endsWith('total') && e.hasOwnProperty(key) && (e[key] != ''))
// ))){
//       disable = true
//     }
    if (!taskStore.current.isValid && !disable) {
      taskStore.current.isValid = true
    }

    setDisableButton(disable)
  }
  let scope = watch("scope")

  useEffect(() => {
    if(bookingData?.current){
        let clist = Utils.getChargeList(JSON.parse(JSON.stringify(bookingData.current)))
        if(stype.toUpperCase().indexOf('LCL') >= 0){
          clist = Utils.groupedCategoryChargeList({ chargeList: clist })
        }
        if(JSON.stringify(chargelist)!=JSON.stringify(clist)){
            setChargelist(clist)
        }
    }
    addlist()
    check()
    let unsubscribe = subscribe(taskStore.current, () => {
      check()

    })
    return unsubscribe

  }, [bookingsStore.current, JSON.stringify(taskStore.current),JSON.stringify(multidest),JSON.stringify(containerDetails)])

  const checkCountry = async (address, country, type, label) => {
    if ((scope.split('-')[0] == 'Port') && (type == 'Origin')) {
      address = address?.slice(address.lastIndexOf("(") + 1, address.length - 1).substring(0, 2)
    }
    if ((scope.split('-')[2] == 'Port') && (type == 'Destination')) {
      address = address?.slice(address.lastIndexOf("(") + 1, address.length - 1).substring(0, 2)
    }
    if ((scope.split('-')[0] == 'Door') && (type == 'Origin')) {
      const data = await MonApi.apost(GET_ADDRESSDETAILS_BY_FILTER_URI, {
  _id: address
})
      address = data[0]?.countryCode
    }
    if ((scope.split('-')[2] == 'Door') && (type == 'Destination')) {
      const data = await MonApi.apost(GET_ADDRESSDETAILS_BY_FILTER_URI, {
  _id: address
})
      address = data[0]?.countryCode
    }
    country = country?.slice(country.lastIndexOf("(") + 1, country.length - 1).substring(0, 2)
    console.log("🚀 ~ checkCountry ~ country:", country)
    console.log("🚀 ~ checkCountry ~ address:", address)
      
    if (address == country) {
      setObj(prev => ({ ...prev, [label]: true }));
    } else {
      setObj(prev => ({ ...prev, [label]: false }));
    }
  }
  
  const checkcontainer = (containerDetails) => {
    let k = {}
    let l = true
    for (let j = 0; j < containerDetails.length; j++) {
      if (containerDetails[j]['containerType'] != undefined && containerDetails[j]['containerType'].length > 0) {
        let c = containerDetails[j]['containerType']
        if (k[c] == undefined) {
          k[c] = Number(containerDetails[j]['wtPerContainer'])
        }
        if (k[c] != Number(containerDetails[j]['wtPerContainer'])) {
          configStore.setModalMessage(
            `Different Container Weight Not Allowed (${containerDetails[j]['containerType']})`
          )
          l = false
        }
      }
    }
    return l
  }

  function sortObjectKeys(arr) {
  if (Array.isArray(arr)) {
    return arr.map(item =>
      Object.keys(item)
        .sort()
        .reduce((acc, key) => {
          acc[key] = item[key];
          return acc;
        }, {})
    );
  }
}
  const onSubmit = async (data, e) => {
    if (checkcontainer(multidest)) {
      // await setdata(data)
      chargesValidationStore.onSaveBtnClicked();

      if (quoteDataRec.shipmentType.toLowerCase().includes("lcl")) {
        if (cargoStore.cargoList.length < 0) {
          configStore.setModalMessage(
            `Please add atleast one cargo Details`
          );
        }
        return;
      }
      return;
    }
  }

  // useEffect(()=>{
  //   if(show){
  // checkCountry(bookingsStore.current.contract.origin, taskStore.current.por, "Origin", "portOfReceipt")
  // checkCountry(bookingsStore.current.contract.origin, taskStore.current.pol, "Origin", "portOfLoading")
  // checkCountry(destination[0].destination, taskStore.current.pod, "Destination", "portOfDischarge")
  // checkCountry(destination[0].destination, taskStore.current.fpod, "Destination", 'finalPlaceOfDelivery')
  //   }
  // },[JSON.stringify(multidest)])

  const getDataForDSR = (booking,obj)=>{
    obj.shipmentScope = booking.shipmentScope
    obj.por = booking.portOfReceipt.slice(booking.portOfReceipt.lastIndexOf('(') + 1, booking.portOfReceipt.lastIndexOf(')'))
    obj.pol = booking.portOfLoading.slice(booking.portOfLoading.lastIndexOf('(') + 1, booking.portOfLoading.lastIndexOf(')'))
    obj.pod = booking.portOfDischarge.slice(booking.portOfDischarge.lastIndexOf('(') + 1, booking.portOfDischarge.lastIndexOf(')'))
    obj.fpod = booking.finalPlaceOfDelivery.slice(booking.finalPlaceOfDelivery.lastIndexOf('(') + 1, booking.finalPlaceOfDelivery.lastIndexOf(')'))
    obj.reworkingPort = booking?.reworkingPort?.slice(booking?.reworkingPort.lastIndexOf('(') + 1, booking?.reworkingPort.lastIndexOf(')'))
    return obj
  }
  let shipmentType = bookingsStore.current.contract.shipmentType
  const [pending,setPending] = useState(false)
  useEffect(()=>{
    async function pendingAction(){
      let ret = await Taskapi.getTaskForAction(bookingsStore.current._id, 'Cost Adjustment Approval')
      setPending(ret.some(e=>e.status == 'PENDING'))
    }
    pendingAction()
  },[])
  return (
    <>
    {pending?<><h1 style={{color:'red'}}>Please Complete Cost Adjustment Approval action which is in Pending and then proceed.</h1></>:<>
    {show && <><div className="flex flex-row gap-[10px] mt-3">
        <AgRoute form={cargoForm} viewonly={false} callback={''} currentShipmentScopes={getShipmentScope(bookingsStore.current.contract.shipmentScope)} />
        <Details form={cargoForm} viewonly={false} applyDefault={false} sd={true} />
      </div>
        <Card className="qoutecard mt-2">
          <div style={{ display: "flex", paddingLeft: "15px" }}>
            <span><img src={ship1} /></span><Headspan
              color="#00000" fontSize="14px" fontWeight="900" data=" Port  Details" />
          </div>
          <div class="columns is-vcentered is-multiline m-1">
            <Col3>
              <AgUnloc
                {..._params(portOfReceiptLable, "por")}
                isValid={obj.portOfReceipt}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, portOfReceipt: list.some(ele => ele === value) })))
                  taskStore.current.por = value
                  checkCountry(bookingsStore.current.contract.origin, taskStore.current.por, "Origin", "portOfReceipt")

                }}
              />

            </Col3>
            <Col3>
              <AgUnloc
                {..._params(portOfLoadingLabel, "pol")}
                isValid={obj.portOfLoading}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, portOfLoading: list.some(ele => ele === value) })))
                  taskStore.current.pol = value
                  checkCountry(bookingsStore.current.contract.origin, taskStore.current.pol, "Origin", "portOfLoading")

                }}
              />
            </Col3>
            {shipmentType.indexOf("LCL") !== -1 &&
            <Col3>
              <AgUnloc
                {..._params('Reworking Port', "reworkingPort")}
                isValid={
                  obj["reworkingPort"]
                }
                callback={(value, list) => {
                  taskStore.current.reworkingPort = value
                }}
              />
            </Col3>}
            <Col3>
              <AgUnloc
                {..._params(portOfDischargeLabel, "pod")}
                isValid={obj.portOfDischarge}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, portOfDischarge: list.some(ele => ele === value) })))
                  taskStore.current.pod = value
                  checkCountry(destination[0].destination, taskStore.current.pod, "Destination", "portOfDischarge")

                }}
              />
            </Col3>
            <Col3>
              <AgUnloc
                {..._params("Final Place of Delivery", "fpod")}
                isValid={obj.finalPlaceOfDelivery}
                callback={(value, list) => {
                  setObj((prev => ({ ...prev, finalPlaceOfDelivery: list.some(ele => ele === value) })))
                  taskStore.current.fpod = value
                  checkCountry(destination[0].destination, taskStore.current.fpod, "Destination", 'finalPlaceOfDelivery')

                }}
                validationMsg="- Please select enter valid UN location."
              />
            </Col3>

          </div></Card>
        <div className="flex flex-row gap-[10px]">
          <p className="text-lg font-bold">Charges Amendment</p>
          <AntSwitch className="mt-1" value={view} onChange={(e) => {
            setView(!view)
            console.log(" the task store is new cargo totals ",taskStore.current)
            if (!e.target.checked) {
              taskStore.current.approvalRequired = false
              // chargesStore1.list = []
              // fclChargesStore.list = []
              taskStore.current.chargesList = []
            }
          }} />
        </div>
        {view && <> <div>
          {
            (shipmentType.toUpperCase().indexOf('LCL') >= 0) ?
              <><p className="text-lg font-bold">Orginal Cost</p>
                <ActChargesView chargelist={chargelist} name={'originalCost'} />
                    <hr/>
                    <p className="text-lg font-bold">Revised Cost</p>
                    <ActChargesComp data={scope} /> </>:
                    <></>
          }
          {
            (shipmentType.toUpperCase().indexOf('AIR') >= 0) ?
              <><p className="text-lg font-bold">Orginal Cost</p>
              <ActChargesAirView chargelist={chargelist} name={'originalCost'}  />
              <hr />
              <p className="text-lg font-bold">Revised Cost</p>
              <ActChargesAirComp  data={scope} /></> :
                  <></>
          }
          {
            (shipmentType.toUpperCase().indexOf('FCL') >= 0) ?
              <><p className="text-lg font-bold">Orginal Cost</p>
               <ActFCLChargesView chargelist={chargelist} container={bookingsStore.current.contract.containerList} name={'originalCost'} />
               <hr />
               <p className="text-lg font-bold">Revised Cost</p>
                <ActFCLChargesComp data={scope} /></> :
                <></>
          }
        </div>
          <div className="flex flex-row gap-[10px]">
            <p className="text-lg font-bold">Approval Required</p>
            <AntSwitch className="mt-1" onChange={(e) => {
              taskStore.current.approvalRequired = e.target.checked
            }} />
          </div></>
          }
      </>}
      {
        (bookingsStore.current.contract.shipmentType == 'LCL') ?
          <Taskfiletable /> : <></>
      }
      <button className="button islink flex float-end"
        onClick={async () => {
          for (let key in data) {
            if (data[key] === undefined || data[key] === "") {
              delete data[key];
            }
            if (bookingsStore.current.contract[key] === undefined && data[key] === 'No') {
                delete data[key];
            }
          }
          let dsrObj={}
          data.multidest.forEach((e, i) => {
            const key = i === 0 ? 'destination' : `destination${i + 1}`;
            data[key] = e.destination;
            dsrObj[key] = e.destination;
          });
          taskStore.current.changesRequired = view
          data.portOfReceipt = taskStore.current.por
          data.portOfDischarge = taskStore.current.pod
          data.portOfLoading = taskStore.current.pol
          data.finalPlaceOfDelivery = taskStore.current.fpod
          data.reworkingPort = taskStore.current.reworkingPort
          taskStore.current.bookingDSR = getDataForDSR(data,dsrObj)
          let cargo =[]
            let multidest_new = []
            data.multidest.forEach((e, i) => {
                  let z = {}
                  z['destination'] = e.destination
                  z['cargoDetails'] = []
                  for (let j = 0; j < e.cargoDetails.length; j++) {
                      let k = e.cargoDetails[j]
                      console.log("🚀 ~ k:", k)
                      k = Utils.setCargo_unit(k,e.cargoDetails[0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
                    let c = Utils.convert_calcCargoDetails(e.cargoDetails[j], scope, bookingsStore.current.contract.shipmentType, false, bookingsStore.current.contract.cargoDimensionUnit, data.volumeInDimensions, bookingsStore?.current?.contract?.isCarting)
                      z['cargoDetails'].push(c)
                      cargo.push(c)
                  }
                  multidest_new.push(z)
                data['cargoList'] = cargo
                
            });
            // bookingsStore.current.contract.multidest.forEach((e, i) => {
            //       let z = {}
            //       z['destination'] = e.destination
            //       z['cargoDetails'] = []
            //       for (let j = 0; j < e.cargoDetails.length; j++) {
            //           let k = e.cargoDetails[j]
            //           console.log("🚀 ~ k:", k)
            //           k = Utils.setCargo_unit(k,e.cargoDetails[0],['weight','chargeableWeight','volume','totalWeight','totalVolume','dimensions'],bookingsStore.current.contract.cargoDimensionUnit)
            //           let c = Utils.convert_calcCargoDetails(e.cargoDetails[j],bookingsStore.current.contract.shipmentScope,bookingsStore.current.contract.shipmentType,false,bookingsStore.current.contract.cargoDimensionUnit)
            //           z['cargoDetails'].push(c)
            //           cargo.push(c)
            //       }
            //       multidest_new.push(z)
            //     data['cargoList'] = cargo

            // });
            console.log(data.cargoList,"checking for cargo list");
          data['iorParty'] = getValues("iorParty")
          data['multidest_new'] = multidest_new 
          data['cargoTotals'] = new QuoteCalcV2(data).calculateCargoTotals(data.cargoList)
          let booking = bookingsStore.current
          
          const isValid = await trigger();
          const allTrue = Object.values(obj).every(val => val === true);
          console.log(!view , disableButton,view , !disableButton , allTrue,"isValid && (!view || !disableButton) && allTrue");
          console.log(" the data before ",data)
           if (isValid && !disableButton && allTrue) {
            taskStore.current.newContract = data
            taskStore.oldtask.newContract = data
            handleSubmit(onSubmit)();
            if (taskStore.current.changesRequired && (JSON.parse(JSON.stringify(chargelist))!=JSON.stringify(taskStore.current.chargesList)) ) {
              taskStore.current.oldchargesList = JSON.parse(JSON.stringify(chargelist))
              taskStore.oldtask.oldchargesList = JSON.parse(JSON.stringify(chargelist))
              taskStore.current.chargesList = taskStore.current.chargesList.filter(e => e.chargeDescription)
              let newchargeList = taskStore.current.chargesList
              let c = taskStore.current.chargesList
              // for (let i = 0; i < c.length; i++) {
              //   c[i]['id'] = booking.contract.chargesList.length + 1
              //   newchargeList.push(c[i])
              // }
              taskStore.current.newchargeList = JSON.parse(JSON.stringify(newchargeList))
            }else{
              taskStore.current.changesRequired = false
              taskStore.current.approvalRequired = false
            }
            if (bookingsStore.current.contract.shipmentType != 'LCL' && taskStore.current.changesRequired && !taskStore.current.approvalRequired) {
               taskStore.current.files[0].label = "Supporting Document"
             }
             if(bookingsStore.current.contract.shipmentType != 'LCL' && !taskStore.current.changesRequired ){
                taskStore.current.files = []
             }
             if (!taskStore.current.approvalRequired && bookingsStore.current.contract.shipmentType == 'LCL' && taskStore.current.changesRequired) {
               taskStore.current.files.push({ "label": "Supporting Document", "filename": "", "invoiceNo": "", "invoiceDate": "", "approved": "", "rejectReason": "" })
             }
            taskStore.current.stage = 1
            taskStore.current.pendingWith = process.env.REACT_APP_ENTERPRISE_NAME_SENTENCECASE.toUpperCase()
            console.log(" the task store is jhhbjjhbfvjhbhvjfvjhbfv jgjfvjbhfv jhgdvjhdv ",taskStore.current)
            // return;
            await Taskapi.saveTask(taskStore.current)
            taskStore.triggerActionVisible = false
            taskStore.myActionVisible = false
            if (AgmodalStore.modalPage === "TaskContainer" || loginStore.isClient()) {
              AgmodalStore.pageVisible = false
              AgmodalStore.apiCall = true
            }
          } else {
            taskStore.current.isValid = false
            configStore.setModalMessage(
              `Please check the fields`
            )
          }
        }
        }>Trigger Action</button>
    </>}
       
      </>
  )
}
